var STORE_SUPPORT_API_CONFIG = {
    baseUrl: '',
    marketLocale: '',
    siteContext: "jabra" /* Jabra */,
};
export var getStoreSupportApiConfig = function () {
    return STORE_SUPPORT_API_CONFIG;
};
export var setStoreSupportApiConfig = function (config) {
    STORE_SUPPORT_API_CONFIG.baseUrl = config.baseUrl;
    STORE_SUPPORT_API_CONFIG.marketLocale = config.marketLocale;
    STORE_SUPPORT_API_CONFIG.siteContext = config.siteContext;
};
